
const NavigationBookingButton = ({ onClick, className, type }) => {
  return (
    <button type={type ? type : 'button'} onClick={onClick} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="68"
        height="64"
        viewBox="0 0 68 64"
      >
        <rect
          id="Rectangle_240"
          data-name="Rectangle 240"
          width="68"
          height="64"
          rx="32"
          fill="#193e8c"
        />
        <g
          id="Icon_feather-arrow-right"
          data-name="Icon feather-arrow-right"
          transform="translate(15 14)"
        >
          <path
            id="Path_15"
            data-name="Path 15"
            d="M7.5,18h21"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
          />
          <path
            id="Path_16"
            data-name="Path 16"
            d="M18,7.5,28.5,18,18,28.5"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
          />
        </g>
      </svg>
    </button>
  );
};

export default NavigationBookingButton;
